import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppClientWrapper"] */ "/app/src/app/_components/Base/AppClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaywallaxMarkII"] */ "/app/src/app/_components/Paywall/PaywallaxMark2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdOptimizelyProvider"] */ "/app/src/app/_lib/providers/AdOptimizelyProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaywallProvider"] */ "/app/src/app/_lib/providers/PaywallProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyFooterProvider"] */ "/app/src/app/_lib/providers/StickyFooterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/app/_lib/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/src/app/_lib/providers/UserProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdShieldScript"] */ "/app/src/app/_lib/scripts/AdShieldScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArcSpanScript"] */ "/app/src/app/_lib/scripts/arcSpan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BomboraScript"] */ "/app/src/app/_lib/scripts/bombora.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FreeStarScript"] */ "/app/src/app/_lib/scripts/freeStar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativoScript"] */ "/app/src/app/_lib/scripts/nativo/wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OneTrustScript"] */ "/app/src/app/_lib/scripts/oneTrust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OutbrainScript"] */ "/app/src/app/_lib/scripts/OutbrainScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PianoScript"] */ "/app/src/app/_lib/scripts/piano/script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuerylyScript"] */ "/app/src/app/_lib/scripts/queryly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_lib/services/GooelOnetap/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_styles/globals.css");
